import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../../APIHelpers/Responses";

export const storeSubCategoryServices = {
  addNewStoreSubCategory,
  updatedStoreSubCategory,
  softDeleteRestoreStoreSubCategory,
  deleteStoreSubCategory,
  getStoreSubCategoryList,
};

// Add New Store Category
async function addNewStoreSubCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStoreSubCategory`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Store Category
async function updatedStoreSubCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedStoreSubCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Store Category
async function softDeleteRestoreStoreSubCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStoreSubCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Store Category
async function deleteStoreSubCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStoreSubCategory`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Store Category
async function getStoreSubCategoryList(categoryId, status, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getStoreSubCategoryList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreSubCategoryList/${categoryId}/${status}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreSubCategoryList/${categoryId}/${status}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}